import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "panel border border-dashed rounded-3 px-8 border-gray-300 mb-5" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-between align-items-center py-5" }
const _hoisted_3 = { class: "title d-flex flex-column justify-content-start" }
const _hoisted_4 = { class: "d-flex flex-row gap-4 align-items-center" }
const _hoisted_5 = { class: "d-flex flex-row align-items-center" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2 fs-7 lh-1" }
const _hoisted_8 = { class: "m-0 text-gray-400 fs-7" }
const _hoisted_9 = { class: "svg-icon svg-icon-4 svg-icon-primary ms-2" }
const _hoisted_10 = { class: "text-gray-400 fs-7 m-0" }
const _hoisted_11 = { class: "tools d-flex flex-row justify-content-end align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-0" }, null, -1)
const _hoisted_13 = { class: "row align-items-start gy-5 py-5" }
const _hoisted_14 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_15 = { class: "m-0 fs-6 lh-1" }
const _hoisted_16 = { class: "text-gray-400 fs-7" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "m-0 fs-6 lh-1" }
const _hoisted_19 = { class: "text-gray-400 fs-7" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = {
  key: 0,
  class: "m-0 fs-6 lh-1"
}
const _hoisted_22 = {
  key: 1,
  class: "m-0 fs-6 lh-1"
}
const _hoisted_23 = { class: "text-gray-400 fs-7" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "m-0 fs-6 lh-1" }
const _hoisted_26 = { class: "text-gray-400 fs-7" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "m-0 fs-6 lh-1" }
const _hoisted_29 = { class: "text-gray-400 fs-7" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "m-0 fs-6 lh-1" }
const _hoisted_32 = { class: "text-gray-400 fs-7" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "m-0 fs-6 lh-1" }
const _hoisted_35 = { class: "text-gray-400 fs-7" }
const _hoisted_36 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_37 = { class: "m-0 fs-6 lh-1" }
const _hoisted_38 = { class: "text-gray-400 fs-7" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "m-0 fs-6 lh-1" }
const _hoisted_41 = { class: "text-gray-400 fs-7" }
const _hoisted_42 = {
  key: 3,
  class: "col-md-4"
}
const _hoisted_43 = { class: "m-0 fs-6 lh-1" }
const _hoisted_44 = { class: "text-gray-400 fs-7" }
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "m-0 fs-6 lh-1" }
const _hoisted_47 = { class: "text-gray-400 fs-7" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "m-0 fs-6 lh-1" }
const _hoisted_50 = { class: "text-gray-400 fs-7" }
const _hoisted_51 = {
  key: 4,
  class: "col-md-4"
}
const _hoisted_52 = {
  key: 0,
  class: "m-0 fs-6 lh-1"
}
const _hoisted_53 = {
  key: 1,
  class: "m-0 fs-6 lh-1"
}
const _hoisted_54 = { class: "text-gray-400 fs-7" }
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = { class: "m-0 fs-6 lh-1" }
const _hoisted_57 = { class: "text-gray-400 fs-7" }
const _hoisted_58 = {
  key: 0,
  class: "separator separator-dashed mb-0"
}
const _hoisted_59 = {
  key: 1,
  class: "d-flex flex-row justify-content-end align-items-center py-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.information.common.address")) + " " + _toDisplayString(_ctx.index + 1), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getStatus(_ctx.data.identification.kyc_status).value.color])
            }, _toDisplayString(_ctx.data.identification.kyc_status_text), 3),
            (_ctx.data.identification.kyc_status == _ctx.KycDisplayStatus.Rejected)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("kyc.information.common.rejectReason")), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.data.identification.kyc_reject_info?.comments), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("kyc.information.common.rejectOperator")) + ": " + _toDisplayString(_ctx.data.identification.kyc_reject_info?.operator_name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "after-title")
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("kyc.information.common.updateBy")) + ": " + _toDisplayString(_ctx.data.updated_by) + " | " + _toDisplayString(_ctx.$t("kyc.information.common.updateDate")) + ": " + _toDisplayString(_ctx.formatUtcDate(_ctx.data.updated_at, "YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _renderSlot(_ctx.$slots, "toolbar")
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      (_ctx.type === _ctx.KycType.Juridical)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.data.identification.company_name || "--"), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("kyc.information.contactInformation.companyName")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type === _ctx.KycType.Natural)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.data.identification.lastname +
                " " +
                _ctx.data.identification.firstname || "--"), 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("kyc.information.contactInformation.name")), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_ctx.data.additional.telephone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString((_ctx.data.additional.area_code
                ? "+" + _ctx.data.additional.area_code
                : "") +
              " " +
              _ctx.data.additional.telephone), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_22, "--")),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("kyc.information.common.tel")), 1)
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.data.identification.address1 || "--"), 1),
        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("kyc.address.street")), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.data.identification.address2 || "--"), 1),
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("kyc.address.houseNo")), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.data.identification.postcode || "--"), 1),
        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("kyc.address.postalCode")), 1)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.data.identification.country || "--"), 1),
        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("kyc.address.country")), 1)
      ]),
      (_ctx.data.identification.country_code === 'CN')
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.data.identification.province || "--"), 1),
            _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("kyc.address.province")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.data.identification.city || "--"), 1),
        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("kyc.address.city")), 1)
      ]),
      (_ctx.data.identification.country_code === 'CN')
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.data.identification.district || "--"), 1),
            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("kyc.address.district")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.data.additional.email || "--"), 1),
        _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("kyc.information.common.email")), 1)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.data.additional.website || "--"), 1),
        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("kyc.information.common.website")), 1)
      ]),
      (_ctx.type === _ctx.KycType.Juridical)
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
            (_ctx.data.additional.telephone)
              ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString((_ctx.data.additional.area_code ? "+" + _ctx.data.additional.area_code : "") +
            " " +
            _ctx.data.additional.telephone), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_53, "--")),
            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("kyc.information.common.tel")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.data.additional.fax || "--"), 1),
        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("kyc.information.common.fax")), 1)
      ])
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58))
      : _createCommentVNode("", true),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ]))
}